import { inject } from "@vercel/analytics";

export default defineNuxtPlugin(() => {
  if (navigator.doNotTrack === "1") {
    return;
  }

  inject();
});
